import React from 'react';
import PropTypes from 'prop-types';
import { paymentInformationReviewTitle } from '../additionalInformation/PaymentInformationReview';
import { hasEnteredBankAccount } from '../additionalInformation/DirectDepositField';
import { capitalizeFirstLetter } from '../../utils/helpers';
import ConfirmationSection from './ConfirmationSection';

const mask = (value, prefix) => (value ? `${prefix}${value.slice(-4)}` : '');

// Mirrors DirectDepositViewField: an account the Veteran entered replaces the
// prefilled (on-file) account, which is stored under `view:` keys.
const getDisplayedAccount = formData => {
  const directDeposit = formData?.directDeposit;
  if (hasEnteredBankAccount(directDeposit)) return directDeposit;

  const prefilled = formData?.['view:prefilledBankAccount'];
  if (!prefilled) return null;

  return {
    accountType: prefilled['view:accountType'],
    bankName: prefilled['view:bankName'],
    accountNumber: prefilled['view:accountNumber'],
    routingNumber: prefilled['view:routingNumber'],
  };
};

const ConfirmationPaymentInformation = ({ formData }) => {
  const account = getDisplayedAccount(formData);
  if (!account) return null;

  return (
    <ConfirmationSection
      title={paymentInformationReviewTitle}
      rows={[
        {
          label: 'Account type',
          value: capitalizeFirstLetter(account.accountType),
        },
        { label: 'Bank name', value: account.bankName || '' },
        {
          label: 'Account number',
          value: mask(account.accountNumber, '******'),
        },
        {
          label: 'Routing number',
          value: mask(account.routingNumber, '*****'),
        },
      ]}
    />
  );
};

ConfirmationPaymentInformation.propTypes = {
  formData: PropTypes.shape({
    directDeposit: PropTypes.shape({
      accountNumber: PropTypes.string,
      accountType: PropTypes.string,
      bankName: PropTypes.string,
      routingNumber: PropTypes.string,
    }),
    'view:prefilledBankAccount': PropTypes.shape({
      'view:accountNumber': PropTypes.string,
      'view:accountType': PropTypes.string,
      'view:bankName': PropTypes.string,
      'view:routingNumber': PropTypes.string,
    }),
  }),
};

export default ConfirmationPaymentInformation;
